module.exports = __webpack_public_path__ + "static/media/facebook_logo.73cf2981.png";